export default __webpack_public_path__ + "static/media/lateralImage.22fcdd37.png";